import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProspectSummary extends Layout {
    labelCreation: Label;
    labelProspect: Label;
    labelQuote: Label;
    panelCreation: Panel;
    panelProspect: Panel;
    panelQuote: Panel;
    sourceProspectSummary: DataSource;
    textboxCreatedDate: Textbox;
    textboxLastCompletedActivity: Textbox;
    textboxLastContactDate: Textbox;
    textboxLastQuoteDate: Textbox;
    textboxQuoteCount: Textbox;
}
